import { Component, HostListener, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { SessionService } from '../../services/session.service';
import { LayoutService } from '../../../@vex/services/layout.service';
import { FilterDialogData } from './FilterDialogData';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AraSearchSelectComponent } from '../util/ara-search-select/ara-search-select.component';

@Component({
	selector: 'vex-filter-dialog',
	templateUrl: './filter-dialog.component.html',
	styleUrls: ['./filter-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		CdkDrag,
		MatIconButton,
		MatIcon,
		CdkDragHandle,
		CdkScrollable,
		MatDialogContent,
		MatProgressSpinner,
		AraSearchSelectComponent,
		MatDialogActions,
		MatButton,
	],
})
export class FilterDialogComponent {
	private translocoLocaleService = inject(TranslocoLocaleService);
	private translocoService = inject(TranslocoService);
	dialogRef = inject<MatDialogRef<FilterDialogComponent>>(MatDialogRef);
	sessionService = inject(SessionService);
	layoutService = inject(LayoutService);
	data = inject<FilterDialogData>(MAT_DIALOG_DATA);

	locale: string;
	filterDialogData: FilterDialogData;
	isMobile = false;

	constructor() {
		const translocoService = this.translocoService;
		const layoutService = this.layoutService;
		const data = this.data;

		this.locale = this.translocoLocaleService.getLocale();
		this.filterDialogData = data;
		this.filterDialogData.initFilterDialogProperties(translocoService);
		this.isMobile = layoutService.isMobile();
	}

	close(saved: boolean): void {
		this.dialogRef.close({
			saved,
			selectedFilters: this.filterDialogData.selectedFilters,
		});
	}

	addFilter(label: string, $event: any[]) {
		this.filterDialogData.selectedFilters.set(label, $event);
	}

	@HostListener('document:keydown.escape', ['$event'])
	onEscapeKey(event: Event): void {
		event.preventDefault();
		this.close(false);
	}
}
